<ng-template #modalPreviewPortal>
    <div class="modal-preview">
        <web-edu-login-modal-preview [styleBag]="previewStyleBag()" />
    </div>
</ng-template>

<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_form_fields_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-input-settings-signal
    [isLoginForm]="true"
    [isEduModalWidget]="isEduModalWidget()"
    [settings]="settings()"
    (valueChangeEvent)="onSettingsChange($event)"
/>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
